var map = {
	"./en": 4620,
	"./en/": 4620,
	"./en/cheatsheets": 143,
	"./en/cheatsheets.ts": 143,
	"./en/community": 5097,
	"./en/community.ts": 5097,
	"./en/documentation": 9346,
	"./en/documentation.ts": 9346,
	"./en/dt": 2486,
	"./en/dt.ts": 2486,
	"./en/en": 6513,
	"./en/en.ts": 6513,
	"./en/footer": 1725,
	"./en/footer.ts": 1725,
	"./en/handbook": 5746,
	"./en/handbook.ts": 5746,
	"./en/head-seo": 3648,
	"./en/head-seo.ts": 3648,
	"./en/index": 4620,
	"./en/index.ts": 4620,
	"./en/index2": 5516,
	"./en/index2.ts": 5516,
	"./en/nav": 5265,
	"./en/nav.ts": 5265,
	"./en/playground": 1327,
	"./en/playground.ts": 1327,
	"./en/tsconfig": 4545,
	"./en/tsconfig.ts": 4545,
	"./inYourLanguage": 310,
	"./inYourLanguage.ts": 310,
	"./zh": 13,
	"./zh/": 13,
	"./zh/community": 7132,
	"./zh/community.ts": 7132,
	"./zh/documentation": 6011,
	"./zh/documentation.ts": 6011,
	"./zh/footer": 6410,
	"./zh/footer.ts": 6410,
	"./zh/handbook": 3397,
	"./zh/handbook.ts": 3397,
	"./zh/head-seo": 2319,
	"./zh/head-seo.ts": 2319,
	"./zh/index": 13,
	"./zh/index.ts": 13,
	"./zh/index2": 7971,
	"./zh/index2.ts": 7971,
	"./zh/nav": 6508,
	"./zh/nav.ts": 6508,
	"./zh/playground": 7396,
	"./zh/playground.ts": 7396,
	"./zh/tsconfig": 966,
	"./zh/tsconfig.ts": 966,
	"./zh/zh": 2027,
	"./zh/zh.ts": 2027
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3606;